/**
 * Copyright (c) 2020 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ParticipantAddressComponent from './participant.address.component';
import { hideModal, updateParticipantAddress } from '../../actions/actions';

export const mapStateToProps = (state) => {
  return {
    error: state.subject.errorUpdateParticipantAddress,
    isLoading: state.subject.isLoadingParticipantAddress,
    currentAddress: {
      addressCity: state.subject.phi.subjectInfo.data.participant.addressCity,
      addressPostalCode: state.subject.phi.subjectInfo.data.participant.addressPostalCode,
      addressStreet: state.subject.phi.subjectInfo.data.participant.addressStreet
    },
    participantId: state.subject.phi.subjectInfo.data.participant.subjectId
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    hide: () => {
      dispatch(hideModal());
    },
    updateParticipantAddress: (participantId, payload) => {
      dispatch(updateParticipantAddress(participantId, payload));
    }
  };
};

const ParticipantAddressModalContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantAddressComponent);

export default ParticipantAddressModalContainer;
